import { ValidationException } from "./validation-exception";

export class ActionValidationException extends ValidationException {
	constructor(action: string, subject: string, reason: string) {
			super(ActionValidationException.createMessage(action, subject, reason));
	}

	private static createMessage(action: string, subject: string, reason: string): string {
			return `Cannot ${action.toLowerCase()} ${subject.toLowerCase()} because ${reason.toLowerCase()}.`;
	}
}
